import React from 'react';

import { Controller } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function CusSelectField({
	itemGrid,
	name,
	label,
	options,
	control,
	fieldStyle,
	multiple,
	defaultValue,
	requiredValue,
	disabled,
	title
}) {
	return (
		<Grid item xs={12} sm={itemGrid}>
			<Controller
				name={name}
				control={control}
				defaultValue={defaultValue}
				color="primary"
				render={({ field }) => {
					if (label === 'Area') {
						return (
							<Autocomplete
								freeSolo
								fullWidth
								multiple={multiple}
								value={field.value}
								limitTags={4}
								disableCloseOnSelect={multiple}
								options={options}
								disabled={disabled}
								getOptionLabel={(option) => (option ? option.label : option)}
								renderOption={(props, option) => (
									<li {...props}>
										<span>{option.label}</span>
									</li>
								)}
								renderInput={(params) => (
									<TextField
										{...params}
										label={label}
										required={requiredValue}
										title={title}
									/>
								)}
								onChange={(_, data, reason) => {
									field.onChange(data);
								}}
							/>
						);
					} else if (label === 'Subarea') {
						return (
							<Autocomplete
								freeSolo
								fullWidth
								multiple={multiple}
								value={field.value}
								limitTags={4}
								disableCloseOnSelect={multiple}
								options={options}
								disabled={disabled}
								groupBy={(option) => option.label}
								getOptionLabel={(option) => (option ? option.value.full : '')}
								renderOption={(props, option) => (
									<li {...props}>
										<span>{option.value.full}</span>
									</li>
								)}
								renderInput={(params) => {
									return <TextField {...params} label={label} title={title} />;
								}}
								onChange={(_, data) => {
									field.onChange(data);
								}}
							/>
						);
					} else {
						return (
							<Autocomplete
								freeSolo
								fullWidth
								multiple={multiple}
								value={field.value}
								limitTags={5}
								disableCloseOnSelect={multiple}
								options={options}
								disabled={disabled}
								getOptionLabel={(option) => (option ? option.label : option)}
								renderOption={(props, option) => (
									<li {...props}>
										<span>{option.label}</span>
									</li>
								)}
								renderInput={(params) => {
									return (
										<TextField
											{...params}
											label={label}
											required={requiredValue}
											title={title}
										/>
									);
								}}
								onChange={(_, data) => {
									field.onChange(data);
								}}
							/>
						);
					}
				}}
			/>
		</Grid>
	);
}

export default React.memo(CusSelectField);
